var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Auth } from 'aws-amplify';
import { atom, selector } from 'recoil';
export const currentAccountState = atom({
    key: 'currentAccountState',
    default: {
        getCurrentAccount: null,
        setCurrentAccount: null
    }
});
export const currentUserState = atom({
    key: 'currentUserState',
    default: {
        getCurrentUser: null,
        setCurrentUser: null,
        updates: 0
    }
});
export const loginFlowUserState = atom({
    key: 'loginFlowUserState',
    default: null,
    dangerouslyAllowMutability: true
});
export const currentAccountStateQuery = selector({
    key: 'currentAccountStateQuery',
    get: () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield Auth.currentAuthenticatedUser();
            return response;
        }
        catch (error) {
            return null;
        }
    }),
    dangerouslyAllowMutability: true
});
export const studentAccountsState = atom({
    key: 'studentAccountsState',
    default: {
        accounts: [],
        checkingAccount: null,
        creditCardAccount: null,
        brokageAccount: null,
        pockets: []
    }
});
export const systemAccountsState = atom({
    key: 'systemAccountsState',
    default: {
        accounts: [],
        mainChecking: null
    }
});
export const confirmHookState = atom({
    key: 'confirmHookState',
    default: {
        show: false,
        confirmed: null,
        title: 'Confirm',
        message: 'Are you sure you want to do this?',
        textConfirm: 'Confirm'
    }
});
